import { getConnectionDetails, getConnectionElement } from "../../lib/connectionDetails";

export const onCartPage = (app) => {

    const placeOnCart = async (handleConnect) => {
        if (!location.href.includes('/cart.php')) return;

        const details = await getConnectionDetails(app.service);

        console.log(details)
        if (!details || !details.positions.cart_page) return;

        const connection = getConnectionElement(details);
        
        const cartTotalsContainer = document.querySelector('[data-cart-totals]');
        const cartTotalsEl = cartTotalsContainer?.querySelector('.cart-totals') ?? cartTotalsContainer?.firstElementChild;
        
        if (!cartTotalsEl) return;
    
        cartTotalsEl.append(connection.connectionElement);
        connection.linkElement?.addEventListener('click', handleConnect);
    }

    window.addEventListener('omnicustomer:ready', () => {
        const handleConnect = window.omniCustomer.api.handleConnect;
        placeOnCart(handleConnect);
    });
}